import React from "react";
import theme from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { logout, deleteUserProfile } from "../../redux/slices/authSlice";

import infoIcon from "../../assets/icons/infoIcon.svg"
import ProfileIconActive from "../../assets/icons/sidebar/profileActive.svg";
import LogoutIcon from "../../assets/icons/logout.svg";
import {
  Container,
  Wrapper,
} from "../../components/ProfileComponent/ProfileTabStyles";

const ProfileTab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: null, 
      iconHtml:
          `<img src=${infoIcon} alt="error" style="width:50px;">`, 
      showCancelButton: true,
      confirmButtonColor: theme.color.brand,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logout());
        navigate("/login");
      }
    });
  };

  const handleDeactivate = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "User information and all records will be cleared!",
      icon: null, 
      iconHtml:
          `<img src=${infoIcon} alt="error" style="width:50px;">`, 
      showCancelButton: true,
      confirmButtonColor: theme.color.brand,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, deactivate!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteUserProfile());
        navigate("/login");
      }
    });
  };
  return (
    <Container>
      <h2>Personal details</h2>
      <div className="profile">
        <img className="circled" src={ProfileIconActive} alt="profile-icon" />
        <div className="texts">
          <h3>
            {user.data?.firstName} {user.data?.lastName}
          </h3>
          <p>{user.data?.userReference}</p>
        </div>
      </div>
      <Wrapper>
        <div>
          <h4>First Name</h4>
          <p style={{textTransform: 'capitalize'}}>{user.data?.firstName}</p>
        </div>

        <div>
          <h4>Last Name</h4>
          <p style={{textTransform: 'capitalize'}}>{user.data?.lastName}</p>
        </div>

        <div>
          <h4>E-mail</h4>
          <p>{user.data?.email}</p>
        </div>
      </Wrapper>

      <h2>Others</h2>
      <div className="footer">
      <div className="logout" onClick={handleLogout}>
        <img src={LogoutIcon} alt="logout" />
        <p>Logout</p>
      </div>
      <p className="deactivate" onClick={handleDeactivate}>Deactivate Account</p>
      </div>
    </Container>
  );
};

export default ProfileTab;
